/*
  The footer's mobile accordion.

  Focal already supplies the disclosure itself: each column heading is one of
  its own `toggle-button`s driving a `collapsible-content` panel, so opening,
  closing, the height animation and the aria-expanded bookkeeping all come
  from theme.js. This file adds only the two things the design needs on top:

    - single-open, the way the design's own mobile footer behaves: opening a
      column closes whichever one was open
    - standing the toggles down at and above 1000px, where the stylesheet
      keeps every panel open and there is nothing left to disclose. The
      button loses aria-expanded and aria-controls there rather than claiming
      to be a collapsed disclosure over content that is plainly visible
*/

(() => {
  const DESKTOP = window.matchMedia('(min-width: 1000px)');

  const toggles = () => document.querySelectorAll('[data-kludi-footer-toggle]');

  const panelOf = (toggle) => document.getElementById(toggle.dataset.kludiFooterPanelId);

  function closeOthers(current) {
    for (const toggle of toggles()) {
      if (toggle === current) continue;

      const panel = panelOf(toggle);

      // focal's own toggle-button listens for openable-element:close and
      // resets its aria-expanded, so the sibling heading follows along
      if (panel && panel.open) panel.open = false;
    }
  }

  function applyBreakpoint() {
    for (const toggle of toggles()) {
      if (DESKTOP.matches) {
        toggle.disabled = true;
        toggle.removeAttribute('aria-expanded');
        toggle.removeAttribute('aria-controls');
        continue;
      }

      // aria-controls goes back first: focal's toggle-button resolves its
      // controlled element through that attribute, so the close below has to
      // be able to reach it
      toggle.disabled = false;
      toggle.setAttribute('aria-controls', toggle.dataset.kludiFooterPanelId);

      const panel = panelOf(toggle);

      if (panel && panel.open) panel.open = false;

      toggle.setAttribute('aria-expanded', 'false');
    }
  }

  function init() {
    for (const toggle of toggles()) {
      // theme.js binds its own click handler when the element upgrades, which
      // happens before this file runs -- so aria-expanded already holds the
      // new state by the time this listener reads it
      toggle.addEventListener('click', () => {
        if (toggle.getAttribute('aria-expanded') === 'true') closeOthers(toggle);
      });
    }

    applyBreakpoint();
    DESKTOP.addEventListener('change', applyBreakpoint);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
